export default {
  home: {
    welcome: 'Welcome'
  },
  tabs: {
    more: 'More',
    closeCurrent: 'Close current',
    closeOther: 'Close other',
    closeAll: 'Close All'
  },
  header: {
    componentSize: 'Component Size',
    language: 'Language',
    theme: 'theme',
    themeSetting: 'Theme setting',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    fullScreen: 'Full Screen',
    exitFullScreen: 'Exit Full Screen',
    personalData: 'Personal Data',
    changePassword: 'Change Password',
    logout: 'Logout'
  }
}
